export const CONTACT = {
  phoneDisplay: '+30 23511 04251',
  phoneHref: 'tel:+302351104251',
  email: 'hello@pixelpro.solutions',
  social: {
    facebook: 'https://www.facebook.com/pixelpro.solutions/',
    linkedin: 'https://www.linkedin.com/in/alex-alali/',
    instagram: 'https://www.instagram.com/pixelpro.solutions/',
    youtube: 'https://www.youtube.com/@PixelproSolutions'
  },
};